import { type FC } from 'react';

import { type IconProps } from './types';

export const MenuCloseV4Icon: FC<IconProps> = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5 21.5L21.5 10" stroke="#00FFBB" strokeWidth="2" strokeLinecap="round" />
      <path d="M10.5 10L21.5 21.5" stroke="#00FFBB" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};
